import React from "react";

export const SkeletonTableView = ({ columCount = 5, rowCount = 5 }) => {

    return (
        <table className="table table-md table-pin-rows table-pin-cols ">
            <thead>
                <tr>
                    {
                        "0".repeat(columCount).split("").map((_, index) =>
                            <th key={`col-${index}`}>
                                <div className="skeleton w-32 h-6 bg-accent"></div>
                            </th>
                        )
                    }
                </tr>
            </thead>
            <tbody>
                {
                    "0".repeat(rowCount).split("").map((_, rowIndex) =>

                        <tr key={`row-${rowIndex}`}>
                            {
                                "0".repeat(columCount).split("").map((_, columnIndex) =>

                                    <th key={`row-${rowIndex}-col-${columnIndex}-data`}>
                                        <div className="skeleton w-32 h-6 bg-accent"></div>
                                    </th>

                                )
                            }
                        </tr>

                    )
                }
            </tbody>
        </table>
    )
}